import { render, staticRenderFns } from "./Level-Up.vue?vue&type=template&id=ba4c2d96"
import script from "./Level-Up.vue?vue&type=script&lang=js"
export * from "./Level-Up.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Level-Up.vue?vue&type=style&index=1&id=ba4c2d96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports